import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const HelpLink = ({ url }) => (
    <div className="ui-helpCenter pp-tabs__help hidden-sm-down">
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="ui-link_questionMark"
        >
            <Svg
                iconName="cirleHelp"
                size="Medium"
            />
        </a>
    </div>
);

HelpLink.propTypes = {
    url: PropTypes.string.isRequired,
};

export default HelpLink;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/HelpLink.jsx